import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import { Button } from './Button';
import { ServerIp } from '../constants/env';

const ButtonWrapper = styled.div`
  margin: 10px 0;
  display: flex;

  > button {
    margin-right: 20px;
  }
`;

export class LocationSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      streets: [],
      locations: [],
      selectedStreetOption: [],
      selectedLocationOption: [],
    };
    this.handleStreetChange = this.handleStreetChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    fetch(`${ServerIp}api/v2/elements/get_streets`, {
      method: 'GET',
      headers: {
        Authorization: `Token token="${token}", identifier="${user}"`,
      },
    })
      .then((res) => {
        res.json()
          .then((data) => {
            this.setState({
              streets: data.streets
                .filter((item) => Boolean(item))
                .map((item) => ({value: item, label: item}))
            })
          })
      })
  }

  handleStreetChange(values) {
    if (!values) {
      this.setState({
        selectedStreetOption: []
      })

      return;
    }
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    let filter = '';
    values.forEach((item) => {
      filter += `location[]=${item.value}&`;
    })

    fetch(`${ServerIp}api/v2/elements/get_locations?${filter}`, {
      method: 'GET',
      headers: {
        Authorization: `Token token="${token}", identifier="${user}"`,
      },
    })
      .then((res) => {
        res.json()
          .then((data) => {
            this.setState({
              selectedStreetOption: values,
              locations: data.locations
                .filter((item) => Boolean(item))
                .map((item) => ({value: item, label: item}))
            })
          })
      })
  }

  handleLocationChange(values) {
    this.setState({
      selectedLocationOption: values
    });
  }

  async handleSubmit() {
    await this.props.getLocationAction({
      location: this.state.selectedLocationOption.map((item) => item.value),
      street: this.state.selectedStreetOption.map((item) => item.value),
    });
    this.props.handleHide();
  }

  render() {
    return (
      <div>
        <span>Select street</span>
        <Select
          value={this.state.selectedStreetOption}
          onChange={this.handleStreetChange}
          options={this.state.streets}
          isMulti
        />
        <br/>
        <span>Select location</span>
        <Select
          value={this.state.selectedLocationOption}
          onChange={this.handleLocationChange}
          options={this.state.locations}
          isMulti
        />
        <ButtonWrapper>
          <Button onClick={this.handleSubmit}>SUBMIT</Button>
          <Button onClick={this.props.onUploadOpen}>UPLOAD FILE</Button>
        </ButtonWrapper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationSelect.js